/**
 * Creates a currency options object with zero amounts for given currencies
 * @param currencies Array of currency codes
 * @returns Currency options object with zero amounts
 */
export const createZeroCurrencyOptions = (currencies: string[]) => {
    return currencies.reduce(
        (acc, currency) => ({
            ...acc,
            [currency]: {
                amount: 0,
                rate: 1,
                lock: false,
                date: new Date().toISOString(),
            },
        }),
        {},
    )
}

